var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"menu-props":{offsetY:true},"item-value":"start","item-text":"start","items":_vm.timeArrays,"dense":_vm.dense,"hide-details":_vm.hideDetails,"label":_vm.$t(_vm.label),"rules":_vm.rules,"outlined":""},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }